/* eslint-disable max-len */
import { memo } from "react";

const Tag = memo((props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 512 512" {...props}>
        <path d="M458.667 0H323.349c-25.643 0-49.771 9.984-67.904 28.117L18.197 265.387C6.635 276.949 0 292.949 0 309.376c0 16.341 6.635 32.341 18.197 43.904l140.544 140.544C170.283 505.365 186.283 512 202.709 512c16.341 0 32.341-6.635 43.904-18.197l237.269-237.269C502.016 238.421 512 214.293 512 188.651V53.333C512 23.915 488.085 0 458.667 0zm-64 170.667c-29.419 0-53.333-23.915-53.333-53.333 0-29.419 23.915-53.333 53.333-53.333S448 87.915 448 117.333c0 29.419-23.915 53.334-53.333 53.334z" />
    </svg>
));

export default Tag;
